import { useMemo } from 'react'
import PropTypes from 'prop-types'

import { useSelector, useDispatch } from 'react-redux'

import { uxEvent, setCurrentCollectionIndex } from '../../../../flux/actions/ux'
import { selectCurrentCollectionIndex } from '../../../../flux/selectors/ux'
import { selectProductCategory, selectCategoryProducts } from '../../../../flux/selectors/products'
import ProductsCarousel from '../ProductsCarousel'
import LoadingSkeleton from '../../Generics/LoadingSkeleton/index'

export const SimilarProductsCarouselSkelton = () => (<LoadingSkeleton height="150px" />)

const SimilarProductsCarousel = ({
  similarProductId,
  containerRef,
  onShowAllClick: onShowAllClickCallback,
}) => {
  const dispatch = useDispatch()

  const currCollectionIndex = useSelector(selectCurrentCollectionIndex)
  const category = useSelector(selectProductCategory(currCollectionIndex))
  const categoryProducts = useSelector(selectCategoryProducts(category))
  const similarProducts = useMemo(
    () => (
      categoryProducts[1]?.filter(({ id }) => id !== similarProductId)),
    [categoryProducts, similarProductId],
  )

  if (!similarProductId) {
    return (<SimilarProductsCarouselSkelton />)
  }

  const onShowAllClick = () => {
    onShowAllClickCallback()
    dispatch(uxEvent({
      name: 'click',
      target: 'ProductDetail/SeeAllSimilarProducts',
      params: { category },
    }))
  }

  const onProductClick = (product, _, carouselIndex) => {
    const { id: productId, collectionIndex } = product

    dispatch(setCurrentCollectionIndex(collectionIndex))
    dispatch(uxEvent({
      name: 'click',
      target: 'SimilarProductsCarousel/Item',
      params: {
        productId,
        category,
        position: carouselIndex + 1,
      },
    }))
  }

  const onProductVisible = (product, _, carouselIndex) => {
    const { id: productId } = product

    dispatch(uxEvent({
      name: 'visible',
      target: 'SimilarProductsCarousel/Item',
      params: {
        productId,
        category,
        position: carouselIndex + 1,
      },
    }))
  }

  return similarProducts?.length >= 2 ? (
    <ProductsCarousel
      similarProductId={similarProductId}
      category={category}
      products={similarProducts}
      onProductClick={onProductClick}
      onProductVisible={onProductVisible}
      onShowAllClick={onShowAllClick}
      containerRef={containerRef}
    />
  ) : null
}

SimilarProductsCarousel.propTypes = {
  similarProductId: PropTypes.string,
  containerRef: PropTypes.shape({}),
  onShowAllClick: PropTypes.func,
}

SimilarProductsCarousel.defaultProps = {
  similarProductId: undefined,
  containerRef: null,
  onShowAllClick: () => false,
}

SimilarProductsCarousel.displayName = 'SimilarProductsCarousel'
SimilarProductsCarousel.whyDidYouRender = true

export default SimilarProductsCarousel
